var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.00005C14 4.44776 14.4477 4.00005 15 4.00005C15.5523 4.00005 16 4.44776 16 5.00005C16 5.55233 15.5523 6.00005 15 6.00005C14.4477 6.00005 14 5.55233 14 5.00005Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.25005C7.37665 5.25005 5.25 7.37669 5.25 10C5.25 12.6234 7.37665 14.75 10 14.75C12.6234 14.75 14.75 12.6234 14.75 10C14.75 7.37669 12.6234 5.25005 10 5.25005ZM6.75 10C6.75 8.20512 8.20507 6.75005 10 6.75005C11.7949 6.75005 13.25 8.20512 13.25 10C13.25 11.795 11.7949 13.25 10 13.25C8.20507 13.25 6.75 11.795 6.75 10Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2583 0.833061C11.7917 0.44562 8.20834 0.44562 4.74177 0.833061C2.72971 1.05794 1.10538 2.64295 0.868826 4.66548C0.454288 8.20978 0.454288 11.7903 0.868826 15.3346C1.10538 17.3571 2.72971 18.9422 4.74177 19.167C8.20835 19.5545 11.7917 19.5545 15.2583 19.167C17.2703 18.9422 18.8946 17.3571 19.1312 15.3346C19.5457 11.7903 19.5457 8.20978 19.1312 4.66548C18.8946 2.64295 17.2703 1.05794 15.2583 0.833061ZM4.90838 2.32378C8.26423 1.94871 11.7358 1.94871 15.0916 2.32378C16.4218 2.47244 17.4872 3.52205 17.6414 4.83973C18.0424 8.26825 18.0424 11.7318 17.6414 15.1604C17.4872 16.478 16.4218 17.5277 15.0916 17.6763C11.7358 18.0514 8.26423 18.0514 4.90838 17.6763C3.57827 17.5277 2.51278 16.478 2.35867 15.1604C1.95767 11.7318 1.95767 8.26825 2.35867 4.83973C2.51278 3.52205 3.57827 2.47244 4.90838 2.32378Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.83f8be75704ea68a4ebe650f597288a2.svg";
export { ForwardRef as ReactComponent };